<template>
    <v-card flat>
    <v-card-title>
        <h4>Выбор объектов плана работ</h4>
    </v-card-title>
    <v-card-text>
        <v-form class="px3">
        <v-select @change="getPlanSubjects"
            item-text="filial"
            item-value="filialid"
            :items="inputPlan.filials"
            v-model="selectedItemsPlan.filial"
            label="Филиал ЦЗЛ, проводящий работы по ДН"
            required
        ></v-select>
        <v-text-field class="pass" v-model="password" label="Пароль" type="password"></v-text-field>
        <v-btn :disabled='selectedItemsPlan.filial == null || this.password == null' @click='planEdit()'>Редактировать план</v-btn>
        </v-form>
    </v-card-text>
</v-card>
</template>
<script>
export default {
  name: 'dnplan',
  data () {
    return {
      password: null,
      planZones: null,
      inputPlan: {filials: [], subjects: [], forestries: []},
      selectedItemsPlan: {filial: null, subject: null, forestries: null},
    }
  },
  mounted: function () {

    this.getPlanZones(new Date().getFullYear())
  },
  computed: {
    
  },
  methods: {
    planEdit() {
      //window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
      if (this.selectedItemsPlan.filial != null && this.password != null) {
        if(this.password == 'filial_'+this.selectedItemsPlan.filial) {
          this.$store.state.user.authenticated = true
          this.$router.push('planedit?filialid=' + this.selectedItemsPlan.filial)
        }
      }
    },
    getPlanSubjects(value) {
      var _this = this
      return this.inputPlan.filials.find(item => item.filialid === value).subjectids
    },
    getPlanZones(year) {
      this.$http.get("api/alldnzones", {params:{'year': year}}).then(res => {
        this.planZones = res.body.zonadn
        this.inputPlan.filials = res.body.zonadn.filter(item => {
          return item['filialid'] != 0
        })
      })
    },
  },
  components: {
  }
}
</script>
<style scoped>
.v-text-field.pass {
  max-width: 20%;
}
</style>